import { SettingsProvider } from './setting/SettingsContext'
import { UserProvider } from './user/UserContext';
import ThemProvider from './theme/ThemProvider';

const Providers = ({ children }) => {
    return (
        <SettingsProvider mode="system">
            <UserProvider>
                <ThemProvider>
                    {children}
                </ThemProvider>
            </UserProvider>
        </SettingsProvider>
    )
}

export default Providers;